/**
 * When deployed, the pricing pages should just be under
 * '/public-pricing', however when testing locally and on the proxy during dev
 * we have different URLs (e.g. /public-pricing-pt-br-service) that'll break
 * if we don't grab the path dynamically
 */
export const getPublicPagePath = () => {
  return `/${window.location.pathname.split('/')[1]}`;
};